import { render, staticRenderFns } from "./FuncTion.vue?vue&type=template&id=d97ccc58&scoped=true"
import script from "./FuncTion.vue?vue&type=script&lang=js"
export * from "./FuncTion.vue?vue&type=script&lang=js"
import style0 from "./FuncTion.vue?vue&type=style&index=0&id=d97ccc58&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d97ccc58",
  null
  
)

export default component.exports